"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGeneratedArticle = void 0;
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const generatedArticleValidation = {
    artNrGenerated: true,
};
function isGeneratedArticle(article) {
    return article != null && echain_shared_modelling_1.UseableUtil.validate(article, generatedArticleValidation);
}
exports.isGeneratedArticle = isGeneratedArticle;
//# sourceMappingURL=GeneratedArticle.js.map